import WaveForm from './Waveform'

export default WaveForm
